import { render } from "./form.vue?vue&type=template&id=71ba3b04&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=71ba3b04&lang=scss&scoped=true"

import exportComponent from "/root/workspace/adx-frontend_wteR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ba3b04"]])

export default __exports__